export const slugValidator = {
  expression: /^(?=.*[a-z])[a-z0-9]+(?:-[a-z0-9]+)*$/,
  message:
    'Must start and end with a letter or number, include at least one letter and contain only lower case letters, numbers or hyphens. For example: "my-name".',
};
